"use client";

import { Box, IconButton, styled } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const Container = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 0,
});

const ArrowButton = styled(IconButton)(({ theme }) => ({
  padding: 0,
  color: theme.palette.secondary.main,
  "& .MuiSvgIcon-root": {
    fontSize: "18px",
  },
}));

export default function ReorderButtons({ onMoveUp, onMoveDown, sx }) {
  return (
    <Container sx={sx}>
      <ArrowButton
        size="small"
        disabled={!onMoveUp}
        onClick={(e) => {
          e.stopPropagation();
          onMoveUp();
        }}
      >
        <KeyboardArrowUpIcon />
      </ArrowButton>
      <ArrowButton
        size="small"
        disabled={!onMoveDown}
        onClick={(e) => {
          e.stopPropagation();
          onMoveDown();
        }}
      >
        <KeyboardArrowDownIcon />
      </ArrowButton>
    </Container>
  );
}
